module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vregi2-ef52bd2f1102c6ad289add924f9522f7.jpg";